import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSection,
  PodFooter,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductRating,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';

export const SupplementalProductPodV7 = (props) => {
  const {
    itemId,
    storeId,
    position,
    parent,
    hideATC,
    scheme,
    noATCFulfillment
  } = props;

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent, position, scheme }}
      render={(pod) => (
        <>
          <PodSection noPadding>
            <div className="sui-grid sui-grid-cols-3 sui-mb-2 sui-gap-2">
              <div className="sui-grid-cols-1">
                <ProductImage
                  itemId={pod.itemId}
                />
              </div>
              <div className="sui-col-span-2">
                <PodSection noPadding columnAlign>
                  <ProductHeader
                    brand="above"
                    itemId={pod.itemId}
                    brandTitleMaxLine={4}
                    disableShopThisCollection
                  />
                  <ProductRating itemId={pod.itemId} />
                  <PodSpacer padding={['T4']}>
                    <Price
                      itemId={pod.itemId}
                      large={false}
                      storeId={storeId}
                      displayEachUom={false}
                      hideSavingsText
                    />
                  </PodSpacer>
                  {!hideATC && (
                    <PodFooter noPadding>
                      <ProductATC
                        itemId={pod.itemId}
                        checkGeneric
                        outline
                        noATCFulfillment={noATCFulfillment}
                      />
                    </PodFooter>
                  )}
                </PodSection>
              </div>
            </div>
          </PodSection>

        </>
      )}
    />
  );
};

SupplementalProductPodV7.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductRating,
  ProductATC,
  Price,
  ProductHeader,
);

SupplementalProductPodV7.propTypes = {
  itemId: stringType.isRequired,
  storeId: stringType,
  position: numType,
  parent: stringType,
  hideATC: boolType,
  scheme: stringType.isRequired,
  noATCFulfillment: boolType
};

SupplementalProductPodV7.defaultProps = {
  storeId: '',
  position: null,
  parent: '',
  hideATC: false,
  noATCFulfillment: true
};
SupplementalProductPodV7.displayName = 'SupplementalProductPodV7';
